module.exports = __webpack_public_path__ + "img/featuredartist (1).7f7c0be4.jpg";